import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function getListPipelines() {
    const data = await axios.get(`${REACT_APP_API}/pipelines/status`);
    return data;
}